import gql from "graphql-tag";

export const uploadModelImage = gql`
  query uploadModelImage($input: UploadModelImageInput!) {
    uploadModelImage(input: $input) {
      presignedUrl
    }
  }
`;

export const uploadModelImageOptions = {
  name: "uploadModelImage",
};
